import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_CODES, ERROR_SEVERITY, ErrorDCR } from '@ddt-web/config';
import { ApplicationNames } from '@ddt-web/domain';
import * as get from 'lodash/get';
import * as isArray from 'lodash/isArray';
import * as isEmpty from 'lodash/isEmpty';

import { ErrorObject } from '../../models/error-object';
import { PopupDialogAction, PopupDialogActionOptions } from '../../models/popup-dialog-object';
import { AbstractErrorHandlerService } from '../abstract-error-handler.service';
import { ErrorHelperService } from '../error-helper.service';
import { ErrorPopupService } from '../error-popup.service';

@Injectable()
export class DashboardPortfolioRetrievalErrorHandlerService extends AbstractErrorHandlerService {
	private flagErrorConfigs = ['associatedPortfolios'];

	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		super(
			contentService,
			errorPopupService,
			tealiumAnalyticsService,
			errorHelperService
		);
	}

	public handleError(error): void {
		const configName = get(error, 'configName', '');
		const errorObject = get(error, 'responseJson');

		// Apply this just for PC Dashboard
		if (error instanceof ErrorObject && this.flagErrorConfigs.includes(configName) && this.errorHelperService.getApplicationName() === ApplicationNames.PORTFOLIO_CENTRE
			&& !errorObject.success && !isArray(errorObject.errorCodes) && !isEmpty(errorObject.errorCodes)) {

			const errorCodes = Object.values(error.responseJson.errorCodes).map(error => error['errorCode']);

			// Unable to get the portfolio id for SECURITY_NOT_FOUND flow due to errorObject not having the portfolio id details
			if (errorCodes.includes(ERROR_CODES.PORTFOLIO_NOT_FOUND) || errorCodes.includes(ERROR_CODES.SECURITY_NOT_FOUND)) {

				// Tracking
				this.errorSeverity = ERROR_SEVERITY.ERROR;
				this.trackErrorMessage = 'notfoundorunauthorized';
				this.tealiumAnalyticsService.trackError(this.trackErrorMessage, this.errorSeverity);

				// Build error message
				this.errorMessage = this.contentService.get('NOT_FOUND_OR_UNAUTHORIZED', ErrorDCR.NOT_FOUND_OR_UNAUTHORIZED);
				const dialogErrorMessage = this.buildErrorMessage();
				dialogErrorMessage.actions = [
					PopupDialogAction.create({
						label: this.contentService.get('ERROR_RETRY_LABEL', ErrorDCR.ERROR_RETRY_LABEL),
						reload: true
					} as PopupDialogActionOptions)
				];

				console.error('There was an error: NOT_FOUND_OR_UNAUTHORIZED', error);
				this.errorPopupService.openResponseMessageDialog(dialogErrorMessage, true);
			}

		} else {
			this.nextHandler.handleError(error);
		}
	}
}
